import { useMemo } from 'react';
import { t } from '@lingui/core/macro';
import { ChevronDown, ChartPie, X } from 'lucide-react';
import { Button, Menu, MenuButton, MenuItem, MenuList, Box } from '@chakra-ui/react';

import useFiltersContext from '@duke-hq/filters/context/useFiltersContext';

export default function ProgressFilter() {
  const { updateFilters, filters } = useFiltersContext();

  const options: { value: 'l25' | '25-75' | 'g75' | '100'; label: string }[] = useMemo(
    () => [
      { value: 'l25', label: t`In progress: < 25%` },
      { value: '25-75', label: t`In progress: 25% - 75%` },
      { value: 'g75', label: t`In progress: > 75%` },
      { value: '100', label: t`Completed` },
    ],
    [],
  );

  const selected = useMemo(() => {
    const option = options.find((opt) => opt.value === filters.percent);
    return option ? option.label : t`Progress`;
  }, [filters.percent, options]);

  return (
    <Menu>
      <MenuButton
        as={Button}
        variant="ghost"
        width="auto"
        colorScheme="gray"
        px={2}
        rightIcon={
          filters.percent !== undefined ? (
            <Box
              minW="fit-content"
              onClick={(e: React.MouseEvent) => {
                e.preventDefault();
                updateFilters({ percent: undefined });
              }}
              ml={1}
            >
              <X size="16px" />
            </Box>
          ) : (
            <ChevronDown size="16px" />
          )
        }
        leftIcon={<ChartPie size="16px" />}
      >
        {selected}
      </MenuButton>
      <MenuList>
        {options.map(({ value, label }) => (
          <MenuItem
            key={label}
            onClick={() => {
              updateFilters({ percent: value });
            }}
          >
            {label}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
}
